export default {
      id: "bee-settings-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "img/icons.b61b1948.svg#bee-settings",
      toString: function () {
        return this.url;
      }
    }